<template>
  <div id="availabilities-base" class="pt-12">
    <div
      class="h-12 flex flex-shrink-0 pt-2 px-6 gap-4 fixed top-18 left-0 z-30 bg-pure-white border-b border-slate-400"
      :style="{ width: 'calc(100vw - 0.5rem)' }"
    >
      <router-link
        v-for="tab in tabs"
        :key="tab.target"
        :to="tab.target"
        class="w-full flex items-center justify-center transition-all duration-300 border-b-4"
        :class="tab.isActive ? 'border-light-purple' : 'border-pure-white'"
      >
        <BlTextSubtitle2 v-if="tab.isActive" :text="tab.label" />
        <BlTextBody1 v-else :text="tab.label" />
      </router-link>
    </div>
    <div id="availabilities-body">
      <Room
        v-if="!$route.params.tab"
        :timeslotView="timeslotView"
        :timeslotViewOptions="timeslotViewOptions"
        @set-timeslot-view="timeslotView = $event"
      />
      <Therapist
        v-if="$route.params.tab === 'therapist'"
        :timeslotView="timeslotView"
        :timeslotViewOptions="timeslotViewOptions"
        @set-timeslot-view="timeslotView = $event"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Room from "./Room.vue";
import Therapist from "./Therapist.vue";

import BlTextSubtitle2 from "../BlTextSubtitle2.vue";
import BlTextBody1 from "../BlTextBody1.vue";
import BlIcon from "../BlIcon.vue";
import BlTextTitle3 from "../BlTextTitle3.vue";

export default {
  name: "Availabilities",
  components: {
    Room,
    Therapist,
    BlTextTitle3,
    BlTextSubtitle2,
    BlTextBody1,
    BlIcon
  },
  data() {
    return {
      timeslotView: "compact", // detailed | compact
      timeslotViewOptions: [
        {
          value: "detailed",
          label: "Detailed view",
          class: "font-bold text-light-purple"
        },
        {
          value: "compact",
          label: "Compact view",
          class: "font-bold text-light-purple"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter"]),
    tabs() {
      return [
        {
          target: "/availabilities",
          isActive: !this.$route.params.tab,
          label: "Rooms"
        },
        {
          target: "/availabilities/therapist",
          isActive: this.$route.params.tab === "therapist",
          label: "Therapists"
        }
      ];
    }
  },
  created() {},
  mounted() {
    const app = document.getElementById("app");
    if (app) {
      app.classList.add("bg-slate-100");
      app.classList.remove("bg-slate-200");
    }
    if (!this.currentUser.role.includes("admin")) {
      return this.$router.push({ name: "Clients" });
    }
    if (!this.currentCenter.enable_appointment) {
      return this.$router.push({ name: "Clients" });
    }
  },
  destroyed() {
    const app = document.getElementById("app");
    if (app) {
      app.scroll({ top: 0, left: 0 });
      app.classList.remove("bg-slate-100");
      app.classList.add("bg-slate-200");
    }
  },
  methods: {
    ...mapActions([""])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/availabilities/Availabilities.vue